import Navbar from "../components/navigation/Navbar";
import Footer from "../components/navigation/Footer";

function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-gsf-sage flex flex-col transition-colors duration-300">
      <Navbar />

      <main className="flex-1">{children}</main>

      <Footer />
    </div>
  );
}

export default MainLayout;
